import { useQuery } from '../lib/queryClient';
import {
  getSubscriptionStatus,
  type OutputType,
} from '../endpoints/subscription/status_GET.schema';

export const SUBSCRIPTION_QUERY_KEY = ['subscription', 'status'] as const;

export function useSubscription() {
  return useQuery<OutputType>({
    queryKey: [...SUBSCRIPTION_QUERY_KEY],
    queryFn: getSubscriptionStatus,
    staleTime: 5 * 60 * 1000, // 5 min cache
  });
}
